import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const styles = {
  dark: "bg-[#1A1A1A] text-[#FFFFFF] hover:bg-[#3A3A3A]",
  outline: "border border-[#1A1A1A]/70 text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#FFFFFF]",
  light: "bg-[#FFFFFF] text-[#1A1A1A] hover:bg-[#F0F0F0]",
  ghostLight: "border border-[#FFFFFF]/60 text-[#FFFFFF] hover:bg-[#FFFFFF] hover:text-[#1A1A1A]",
};

export const Btn = ({ to, children, variant = "dark", className = "", testid, ...rest }) => (
  <Link to={to} data-testid={testid} {...rest}
    className={`group inline-flex items-center justify-between gap-6 min-h-[52px] px-6 text-[0.78rem] tracking-[0.14em] uppercase transition-colors duration-500 ${styles[variant]} ${className}`}>
    <span>{children}</span>
    <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.25} />
  </Link>
);

export const SectionLabel = ({ n, children, light = false }) => (
  <p className={`eyebrow flex items-center gap-4 ${light ? "text-[#CCCCCC]" : "text-[#555555]"}`}>
    <span>({String(n).padStart(2, "0")})</span><span className={`w-8 h-px ${light ? "bg-[#CCCCCC]" : "bg-[#555555]"}`} /><span>{children}</span>
  </p>
);
